import script from "./DiceLabelingTool.vue?vue&type=script&setup=true&lang=js"
export * from "./DiceLabelingTool.vue?vue&type=script&setup=true&lang=js"

import "./DiceLabelingTool.vue?vue&type=style&index=0&id=7ed7a0e8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7ed7a0e8"]])

export default __exports__